import { useCallback, useEffect, useState } from "react"
import { veloeGraphQlApi } from "../../api/graphql/graphQLAPI";
import AXIS_QUERY from '../../queries/axis.js'

export const useAxisCategory = (vehicleType) => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    const requestAxisList = useCallback(async () => {
        try {
            setIsLoading(true);

            const list = await veloeGraphQlApi(AXIS_QUERY, {
                categoria: vehicleType
            })

            setData(list.consultaCategorias)
        } catch (error) {
            setIsError(error)
        } finally {
            setIsLoading(false);
        }
    }, [vehicleType])

    useEffect(() => {
        requestAxisList()
    }, [requestAxisList])

    return {
        data,
        isLoading,
        isError,
    }
}